export default __webpack_public_path__ + "static/media/stock-up.4165e302.png";